import { render, staticRenderFns } from "./follow-up-monitoring.vue?vue&type=template&id=5eedba67&scoped=true&"
import script from "./follow-up-monitoring.vue?vue&type=script&lang=js&"
export * from "./follow-up-monitoring.vue?vue&type=script&lang=js&"
import style0 from "./follow-up-monitoring.vue?vue&type=style&index=0&id=5eedba67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eedba67",
  null
  
)

export default component.exports